module.exports = __webpack_public_path__ + "img/Isle of Man.7b318f07.svg";